import { parse } from 'clustal-js'

import BaseMSA from './BaseMSA.ts'

export default class ClustalMSA extends BaseMSA {
  private MSA: ReturnType<typeof parse>

  constructor(text: string) {
    super()
    this.MSA = parse(text)
  }

  getMSA() {
    return this.MSA
  }

  getRow(name: string): string {
    return this.MSA.alns.find(aln => aln.id === name)?.seq ?? ''
  }

  getWidth() {
    // 0 for an empty alignment (e.g. unrecognized text routed here as fallback)
    // rather than crashing on alns[0]
    return this.MSA.alns[0]?.seq.length ?? 0
  }

  getHeader() {
    return this.MSA.header
  }

  getNames() {
    return this.MSA.alns.map(aln => aln.id)
  }

  get seqConsensus() {
    return this.MSA.consensus
  }
}
